export default __webpack_public_path__ + "static/media/profile2.4454174e.svg";